import { render, staticRenderFns } from "./table-cell.vue?vue&type=template&id=2f6de481&scoped=true"
import script from "./table-cell.vue?vue&type=script&lang=js"
export * from "./table-cell.vue?vue&type=script&lang=js"
import style0 from "./table-cell.vue?vue&type=style&index=0&id=2f6de481&prod&lang=css"
import style1 from "./table-cell.vue?vue&type=style&index=1&id=2f6de481&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6de481",
  null
  
)

export default component.exports